// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2vzQG","paramInput":"JobSimulator_paramInput__1XvYP","input":"JobSimulator_input__1-tHL"};